import { TreeTooltip } from '../TreeTooltip';
import styles from './PopoutTree.module.css';

interface BranchLabelProps {
  branch: string;
  branchDescription?: string;
}

export const BranchLabel = ({
  branch,
  branchDescription,
}: BranchLabelProps) => {
  return (
    <div className={styles.branchContainer}>
      <div className={styles.branchLabel}>{branch}</div>
      {branchDescription && <TreeTooltip label={branchDescription} mt="-1px" />}
    </div>
  );
};
